import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.8333 10.8334H10.8333V15.8334H9.16663V10.8334H4.16663V9.16669H9.16663V4.16669H10.8333V9.16669H15.8333V10.8334Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgAdd);
export default ForwardRef;
